export type Team = {
  id: number;
  name: string;
  leader: number | null;
};
